module.exports = __webpack_public_path__ + "img/wx.5515792d.png";